import Request from './request'

const DeviceLocation = {
  getDeviceTrack (id, params, callback) {
    Request.post('device-location/track/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceLocation (id, callback) {
    Request.get('device-location/last/' + id).then(callback).catch(this.bad_answer)
  },
  getDeviceLocationHistory (fid, params, callback) {
    Request.get('device-location/history/' + fid, params).then(callback).catch(this.bad_answer)
  },
  getDeviceLocationHistoryView (fid, callback) {
    Request.get('device-location/history-view/' + fid).then(callback).catch(this.bad_answer)
  },
  getDeviceCoord (fid, callback) {
    Request.get('device-location/get-coord/' + fid).then(callback).catch(this.bad_answer)
  },
  updateDeviceCoord (params, callback) {
    Request.post('device-location/update-coord', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  removeDeviceCoord (fid, callback) {
    Request.delete('device-location/delete-coord/' + fid).then(callback).catch(this.bad_answer)
  },
}
export default DeviceLocation
